// Order paperwork helpers shared by the Paperwork tab, a task's form card and
// the chart's task-link editor.

// Fill out re-fills a form's clean source, so it is offered only where there
// is one: the server says (`editable`); an older answer falls back on "not an
// upload".
export const isEditableForm = (form) => form?.editable ?? !form?.uploaded;

// Why a form can't be shown to this person, in words. The server's 403s say
// why themselves — which role it read (and where a clinic schema disagrees,
// so whoever is testing knows it's just the role to fix), or whose task this
// is; an older server's bare code gets a sentence instead.
export function paperworkLoadError(err) {
  if (err?.status === 404) return "This form isn't on a chart you can open.";
  const said = err?.message || String(err);
  if (err?.status === 403 && /^forbidden_/.test(said)) {
    return "Your role can't open order paperwork — ask whoever assigned this to reassign it.";
  }
  return said;
}
